import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class TemporaryServiceService {
  private showMessage = true;

  shouldShowMessage(): boolean {
    return this.showMessage;
  }

  hideMessage(): void {
    this.showMessage = false;
    localStorage.setItem('hideTemporaryMessage', 'true');
  }
}
